const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    VERTICAL_LAYOUT_COLLAPSED: 'left_menu_collapsed_',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};
export const LANGUAGES: {
    key: string;
    name: string;
    rtl?: boolean;
}[] = [
    {
        key: 'en',
        name: 'English'
    },
    {
        key: 'es',
        name: 'Spanish'
    }
];
export default LAYOUT_CONST;
const ORDERS = {
    '/orders': ['trading_accounts'],
    '/orders/pending': ['trading_accounts'],
    '/orders/paid': ['trading_accounts'],
    '/orders/rejected': ['trading_accounts']
};

const SUPPORT = {
    '/support': ['tickets'],
    '/support/tickets': ['tickets']
};
export const SECTIONS: {
    AlwaysAvailable: string[];
    Onboarding: string[];
    PathToSections: { [key: string]: string[] };
} = {
    AlwaysAvailable: [
        '/dashboard',
        '/profile',
        '/pages/error',
        '/trading-tools',
        '/analysis-hub',
        '/home',
        '/challenges',
        '/calendar',
        'https://instantfunding.com/trading-rules/',
        '/downloads',
        '/competitions'
    ],
    Onboarding: ['/challenges', '/home', '/profile', '/pages/error', '/downloads', '/competitions']
        .concat(Object.keys(SUPPORT))
        .concat(Object.keys(ORDERS)),
    PathToSections: {
        '/home': ['trading_accounts'],
        '/certificates': ['certificates'],
        '/withdrawals': ['funds-withdraw', 'funds-deposit', 'funds-transactions', 'bank_accounts', 'other_accounts'],
        '/withdrawals/deposit': ['funds-deposit'],
        '/withdrawals/overview': ['funds-withdraw'],
        '/withdrawals/transactions': ['funds-transactions'],
        '/withdrawals/bank-accounts': ['bank_accounts'],
        '/withdrawals/accounts': ['other_accounts'],
        '/platforms': ['platforms'],
        '/downloads': ['platforms'],
        '/kyc': ['compliance'],
        '/partnertships': [''],
        '/trading-tools': ['trading-tools'],
        '/analysis-hub': ['analysis-hub'],
        '/trading': ['trading_tools'],
        '/request': ['requests'],
        '/get-started': [''],
        '/challenges': [''],
        ...SUPPORT,
        ...ORDERS
    }
};
export const RowsPerPageOptions: number[] = [10, 20, 50, 100, 150, 200, 500];
export const DEFAULT_LOGO_URL = '';
export enum OnboardingStatus {
    Onboarded = 'onboarded', //eslint-disable-line
    Rejected = 'rejected', //eslint-disable-line
    Pending = 'pending', //eslint-disable-line
    New = 'new' //eslint-disable-line
}
export enum Status {
    Paid = 'paid',
    Approved = 'approved',
    Pending = 'pending',
    InVerification = 'in_verification',
    Rejected = 'rejected',
    InProgress = 'in-progress',
    Passed = 'passed',
    Active = 'active',
    Suspended = 'suspended',
    Cancelled = 'cancelled',
    Deleted = 'deleted',
    Failed = 'failed'
}
export const RISE = 'RISE';
export const WithdrawalMethods = [
    {
        key: 'crypto',
        label: 'Crypto'
    },
    {
        key: 'other',
        label: RISE
    }
];
export const NAME_REGEX = /^[\p{L}\p{M}\s`.,'\-]{1,50}$/u;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[0-9]).{8,}$/;
export const POSTCODE_REGEX = /^[A-Za-z0-9\s\-\p{L}]{3,10}$/u;
export const ADRESS_REGEX = /^[A-Za-z0-9\s.,#'/\-\p{L}]{3,100}$/u;
export const STATE_REGEX = /^[A-Za-z\s\p{L}]{2,50}$/u;
export const CITY_REGEX = /^[A-Za-z0-9\s.,'\-\p{L}]{2,50}$/u;

export const styles = {
    container: {
        backgroundColor: 'dark.light',
        borderRadius: '16px',
        padding: '16px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
};
export const cryptos = [{ name: 'USDC ERC20', symbol: 'USDC ERC' }];
export const currencies = [
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'ANG',
    'AOA',
    'ARS',
    'AUD',
    'AWG',
    'AZN',
    'BAM',
    'BBD',
    'BDT',
    'BGN',
    'BHD',
    'BIF',
    'BMD',
    'BND',
    'BOB',
    'BRL',
    'BSD',
    'BTN',
    'BWP',
    'BYR',
    'BZD',
    'CAD',
    'CDF',
    'CHF',
    'CKD',
    'CLP',
    'CNY',
    'COP',
    'CRC',
    'CUP',
    'CVE',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'EUR',
    'EGP',
    'ERN',
    'ETB',
    'FJD',
    'FKP',
    'FOK',
    'GBP',
    'GEL',
    'GGP',
    'GHS',
    'GIP',
    'GMD',
    'GNF',
    'GTQ',
    'GYD',
    'HKD',
    'HNL',
    'HRK',
    'HTG',
    'HUF',
    'IDR',
    'ILS',
    'IMP',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JEP',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KGS',
    'KHR',
    'KID',
    'KMF',
    'KPW',
    'KRW',
    'KWD',
    'KYD',
    'KZT',
    'LAK',
    'LBP',
    'LKR',
    'LRD',
    'LSL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MNT',
    'MOP',
    'MRO',
    'MUR',
    'MVR',
    'MWK',
    'MXN',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PAB',
    'PEN',
    'PGK',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SBD',
    'SCR',
    'SDG',
    'SEK',
    'SGD',
    'SHP',
    'SLL',
    'SOS',
    'SRD',
    'SSP',
    'STD',
    'SYP',
    'SZL',
    'THB',
    'TJS',
    'TMT',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TVD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'USD',
    'UYU',
    'UZS',
    'VND',
    'Hào',
    'VUV',
    'WST',
    'XCD',
    'YER',
    'ZAR',
    'ZMW',
    'ZWL'
];
export const CRYPTO_DEFAULT_CURRENCY = 'USDC ERC';
